import React, { useEffect, useState } from "react";
import {
  Row,
  Col,
  Card,
  CardBody,
  CardHeader,
  CardTitle,
  Input,
} from "reactstrap";
import { connect } from "react-redux";
import { setBreadcrumbItems } from "../../store/actions";
import Spinners from "components/Common/Spinner";
import * as url from "../../helpers/url_helper";
import "flatpickr/dist/themes/material_blue.css";
import { MDBDataTable } from "mdbreact";
import { Link, useLocation } from "react-router-dom";
import { Modal, Button } from "react-bootstrap";
import { toast } from "react-toastify";
const data = {
  loading: true,
  errors: {},
  ResErrors: {},
  RoleList: [],
  sangathanList: [],
  isRedirect: false,
  sangathanId: null,
  dropdownData: [],
  sangathanName: "",
  selectedSangathan: {
    label: null,
    name: null,
    _id: null,
    parentId: null,
    options: [],
  },
  currentEditItem: {},
  itemLoading: false,
  itemDeleteLoading: false,
  deleteItemId: null,
  moveItemSelected: {},
  isPrepareMove: false,
  isMoving: false,
  moveTargetItem: {},
  token: "Bearer SECRET",
  errors: {},
};
const SangathanCreate = (props) => {
  document.title = "Sangathan List - VUF";
  const [Values, setValues] = useState(data);
  const location = useLocation();

  const hierarchy = location.state?.hierarchy || [];
  const breadcrumbItems = [
    { title: "VUF", link: "#" },
    { title: "Sangathan List", link: "#" },
  ];

  const [isLoading, setLoading] = useState(false);
  const [sangathanList, setSangathanList] = useState([]);
  const [sangathanUserList, setSangathanUserList] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [editSangathanModal, setEditSangathanModal] = useState(false);
  const [sangathanId, setSangathanId] = useState("");
  const [sangathanName, setSangathanName] = useState("");
  // const [SangathanId, setSangathanId] = useState();
  useEffect(() => {
    props.setBreadcrumbItems("List", breadcrumbItems);
  });

  useEffect(() => {
    _getUserCred();
  }, []);
  const handleEditSangathan = (id, name) => {
    setSangathanId(id);
    setSangathanName(name);
    setEditSangathanModal(true);
  };
  const handleEditSubmit = async (e) => {
    e.preventDefault();
    try {
      const res = await fetch(
        url.url + `/sangathan/rename-sangathan/${sangathanId}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ _id: sangathanId, name: sangathanName }),
        }
      );

      if (res.ok) {
        toast.success("Sangathan name updated successfully!");
        setEditSangathanModal(false);
        setSangathanList((prev) =>
          prev.map((item) =>
            item._id === sangathanId
              ? { ...item, name: sangathanName } // update this one
              : item
          )
        );
      } else {
        console.error("Update failed");
      }
    } catch (error) {
      console.error("Error updating Sangathan:", error);
    }
  };
  function _getUserCred() {
    let user = localStorage.getItem("user");
    user = JSON.parse(user);

    const role = localStorage.getItem("role");

    let state = user;
    let sangathanId = state?.sangathanId || "";
    const Role = state.role || "Member";
    setValues((prevState) => ({
      ...prevState,
      user: state,
      role: state.role,
      isMember: !state.role || state.role?.toLowerCase() == "member" || false,
      sangathanId: sangathanId,
      token: localStorage.getItem("token"),
      loading: true,
    }));
    onGetSangathanList();
  }

  function onGetSangathanList(SangathanId = null) {
    setLoading(true);
    const urlPath = SangathanId
      ? `/sangathan/get-sangathan-user-list?sangathanId=${SangathanId}`
      : "/sangathan/get-all-sangathan-list";

    fetch(url.url + urlPath, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
      .then((response) => response.json())
      .then(async (responseData) => {
        if (responseData.status) {
          if ("sangathanList" in (responseData.response || {})) {
            setSangathanList(responseData.response.sangathanList);
          } else if ("memberList" in (responseData.response || {})) {
            setSangathanUserList(responseData.response.memberList);
          }
        } else {
          console.error("API Error:", responseData.error || "Unknown error");
        }
      })
      .catch((error) => {
        console.log("err", error);
      })
      .finally((final) => {
        setLoading(false);
      });
  }

  /**
   *
   * @param null
   * @description This function validate inputs
   * @returns boolean
   */
  function handleValidation(sangathan) {
    let errors = {};
    let formIsValid = true;
    const stringRegex = /^[A-Za-z]{3,}$/;
    const charRegex = /.{3,}/;

    if (Values.sangathanName?.trim() === "") {
      formIsValid = false;
      errors.sangathanName = "Please enter sangathan name";
    }

    if (!charRegex.test(Values.sangathanName)) {
      formIsValid = false;
      // errors.sangathanName = "Please enter only string with minimum 3 characters";
      errors.sangathanName = "Please enter minimum 3 characters";
    }

    if (sangathan.name == Values.sangathanName) {
      formIsValid = false;
      errors.sangathanName = "You have not made any changes";
    }

    Values.errors = errors;

    return formIsValid;

    // if (!this.handleValidation()) {
    //     return false
    // }
  }

  function onRenameSangathan(e, sangathan) {
    e.preventDefault();

    // const { signOut } = this.context;

    if (!this.handleValidation(sangathan)) {
      return false;
    }

    const Body = JSON.stringify({
      _id: Values.currentEditItem?._id,
      name: Values.sangathanName.trim(),
    });

    let urlPath = "sangathan/rename-sangathan";

    // console.log("rename sangathannn =>", Constants.url + urlPath, token, Body)

    // this.setState({ loading: false });
    // return

    fetch(url.url + urlPath, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: Values.token,
      },
      body: Body,
    })
      .then((response) => response.json())
      .then(async (responseData) => {
        if (responseData.status && "response" in responseData) {
          alert("Sangathan Renamed Successfully.");
          Values.sangathanName = "";
          Values.currentEditItem = {};
          setSangathanList(responseData?.response?.sangathanList || []);
          // this.redirectWithPath("/sangathan-create")
        } else if (!responseData.status && "auth" in responseData) {
          // AuthController.Logout();
        } else if (!responseData.status && responseData.error) {
          alert(responseData?.error || "Error");
        } else {
          alert("Something went wrong, Please try again after sometime.");
        }
      })
      .catch((error) => {
        console.log("err", error);
        alert("Something went wrong, Please try again after sometime.");
      })
      .finally((final) => {});
  }

  function onCheckDeleteSangathan(e, sangathan) {
    e.preventDefault();

    const Body = JSON.stringify({
      _id: sangathan?._id,
    });

    let urlPath = "sangathan/check-delete-sangathan";

    fetch(url.url + urlPath, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: Values.token,
      },
      body: Body,
    })
      .then((response) => response.json())
      .then(async (responseData) => {
        if (responseData.status && "response" in responseData) {
          if (responseData.response.readyToDelete) {
            onDeleteSangathan(e, sangathan);
          } else {
            alert("Something went wrong, Please try again after sometime.");
          }

          // this.redirectWithPath("/sangathan-create")
        } else if (!responseData.status && "auth" in responseData) {
          //AuthController.Logout();
        } else if (
          !responseData.status &&
          responseData.error &&
          responseData.linkedChild
        ) {
          if (responseData.linkedChild.length > 0) {
            let list = "";
            responseData.linkedChild.map((s, i) => {
              list += "- " + s?.name + "\n" || "-" + "\n ";
            });

            if (responseData.type == "HAS_MEMBER") {
              alert(
                `${responseData?.error} \n\n ChildSangathans:\n${list}` ||
                  "Error"
              );
            } else {
              const confirmDelete = window.confirm(
                `${responseData?.error} \n\n ChildSangathans:\n${list}` ||
                  "Error"
              );
              if (confirmDelete) {
                // Delete the item or perform the desired action
                console.log("Item deleted.");
                onDeleteSangathan(e, sangathan);
              } else {
                console.log("Deletion canceled.");
              }
            }
          }
        } else if (!responseData.status && responseData.error) {
          alert(responseData?.error || "Error");
        } else {
          alert("Something went wrong, Please try again after sometime.");
        }
      })
      .catch((error) => {
        console.log("err", error);
        alert("Something went wrong, Please try again after sometime.");
      })
      .finally((final) => {
        Values.deleteItemId = null;
      });
  }

  // DIRECT API TO REMOVE SANGATHAN BUT DO NOT CALL BEFORE CHECK DELETE API
  function onDeleteSangathan(e, sangathan) {
    e.preventDefault();

    // const { signOut } = this.context;

    Values.itemDeleteLoading = true;

    const Body = JSON.stringify({
      _id: sangathan?._id,
    });

    let urlPath = "sangathan/delete-sangathan";

    // this.setState({ loading: false });
    // return

    fetch(url.url + urlPath, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: Values.token,
      },
      body: Body,
    })
      .then((response) => response.json())
      .then(async (responseData) => {
        if (responseData.status && "response" in responseData) {
          alert("Sangathan Removed Successfully.");
          Values.sangathanName = "";
          Values.currentEditItem = {};
          setSangathanList(responseData?.response?.sangathanList || []);
          // this.redirectWithPath("/sangathan-create")
        } else if (!responseData.status && "auth" in responseData) {
          // AuthController.Logout();
        } else if (
          !responseData.status &&
          responseData.error &&
          responseData.linkedChild
        ) {
          if (responseData.linkedChild.length > 0) {
            console.log("DATA ", responseData);
            if (responseData.type == "HAS_MEMBER") {
              alert(responseData?.error || "Error");
            } else {
              let list = "";
              responseData.linkedChild.map((s, i) => {
                list += "- " + s?.name || "-" + "\n ";
              });

              const confirmDelete = window.confirm(
                `${responseData?.error} \n\n ChildSangathans:\n${list}` ||
                  "Error"
              );
              if (confirmDelete) {
                // Delete the item or perform the desired action
                console.log("Item deleted.");
              } else {
                console.log("Deletion canceled.");
              }
            }
          }
        } else if (!responseData.status && responseData.error) {
          alert(responseData?.error || "Error");
        } else {
          alert("Something went wrong, Please try again after sometime.");
        }
      })
      .catch((error) => {
        console.log("err", error);
        alert("Something went wrong, Please try again after sometime.");
      })
      .finally((final) => {
        Values.deleteItemId = null;
      });
  }

  function onCancelEdit(sangathan) {
    Values.currentEditItem = {};
    Values.sangathanName = "";
    Values.errors = {};
  }
  function onSetEdit(sangathan) {
    Values.currentEditItem = sangathan;
    Values.sangathanName = sangathan.name;
  }

  function handleDeleteClick(e, sangathan) {
    const confirmDelete = window.confirm(
      "Are you sure you want to delete this sangathan?"
    );
    if (confirmDelete) {
      // Delete the item or perform the desired action
      Values.deleteItemId = sangathan._id;
      onCheckDeleteSangathan(e, sangathan);
      // this.onDeleteSangathan(e,sangathan)
      console.log("Item deleted.");
    } else {
      console.log("Deletion canceled.");
    }
  }

  function setMoveItem(e, sangathan) {
    Values.moveItemSelected = sangathan;
    Values.isPrepareMove = true;
  }

  function cancelMove(e, sangathan) {
    Values.moveItemSelected = {};
    Values.isPrepareMove = false;
  }

  function confirmTarget(e, sangathan) {
    const confirmMove = window.confirm(
      `Move this ${Values.moveItemSelected.name.toUpperCase()} to ${sangathan.name.toUpperCase()} with its users, You can not undo this action, Are you sure?`
    );
    if (confirmMove) {
      setTargetItem(e, sangathan);
    } else {
      console.log("move canceled.");
      Values.isMoving = false;
      Values.moveItemSelected = {};
      Values.isPrepareMove = false;
      Values.moveTargetItem = {};
    }
  }

  function setTargetItem(e, sangathan) {
    console.log(`Moving ${Values.moveItemSelected.name} to ${sangathan.name}`);

    Values.isMoving = true;
    Values.moveTargetItem = sangathan;

    onMoveSangathan(sangathan);
    // setTimeout(() => {
    //     this.setState({ isMoving : false, moveItemSelected : {}, isPrepareMove : false, moveTargetItem : {}  })
    // }, 3000)
  }

  function onMoveSangathan(targetSangathan) {
    // const { signOut } = this.context;

    if (!Values.moveItemSelected?._id && !targetSangathan?._id) {
      return false;
    }

    const Body = JSON.stringify({
      sourceId: Values.moveItemSelected?._id,
      targetId: targetSangathan?._id,
    });

    let urlPath = "sangathan/move-sangathan";

    fetch(url.url + urlPath, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: Values.token,
      },
      body: Body,
    })
      .then((response) => response.json())
      .then(async (responseData) => {
        if (responseData.status && "response" in responseData) {
          setTimeout(async () => {
            alert("Sangathan Moved Successfully.");
            Values.isMoving = false;
            Values.moveItemSelected = {};
            Values.isPrepareMove = false;
            Values.moveTargetItem = {};
            setSangathanList(responseData?.response?.sangathanList || []);
          }, 2000);
        } else if (!responseData.status && "auth" in responseData) {
          //AuthController.Logout();
        } else if (!responseData.status && responseData.error) {
          alert(responseData?.error || "Error");
          Values.isMoving = false;
          Values.moveItemSelected = {};
          Values.isPrepareMove = false;
          Values.moveTargetItem = {};
        } else {
          alert("Something went wrong, Please try again after sometime.");
          Values.isMoving = false;
          Values.moveItemSelected = {};
          Values.isPrepareMove = false;
          Values.moveTargetItem = {};
        }
      })
      .catch((error) => {
        console.log("err", error);
        alert("Something went wrong, Please try again after sometime.");
        Values.isMoving = false;
        Values.moveItemSelected = {};
        Values.isPrepareMove = false;
        Values.moveTargetItem = {};
      })
      .finally((final) => {
        // return this.setState({ isMoving : false, moveItemSelected : {}, isPrepareMove : false, moveTargetItem : {}  })
      });
  }
  
  const formattedList = sangathanList.map((data) => ({
    ...data,
    sangathanName: [
      <Link
        to={`/parent-sangathan-list/${data._id}`}
        state={{
          hierarchy: [
            ...(location.state?.hierarchy || []),
            { id: data._id, name: data.name },
          ],
        }}
      >
        {data.name}({data.parentSangathanCount})
      </Link>,
      //   Values.currentEditItem?._id == data._id ? (
      //     <>
      //       <input
      //         type="text"
      //         name="sangathanName"
      //         className="form-control form-control"
      //         placeholder={data?.name || "Sangathan name"}
      //         value={Values.sangathanName}
      //       />
      //       <span className="form-text text-danger">
      //         {Values.errors?.sangathanName}
      //       </span>
      //     </>
      //   ) : (
      //     (
      //       <input
      //         type="text"
      //         name="s"
      //         className="form-control-plaintext form-control"
      //         style={{
      //           outline: "none",
      //           paddingLeft: "1rem",
      //           paddingRight: "1rem",
      //           border: "none",
      //         }}
      //         value={data?.name || "-"}
      //       />
      //     ) || "-"
      //   ),
    ],
    Action: [
      <>
        <button
          className="btn btn-primary me-2"
          onClick={() => {
            setShowModal(true);
            onGetSangathanList(data._id);
          }}
        >
          <i className="fa fa-eye" title="View User"></i>
        </button>
        {/* {data._id == Values.deleteItemId ? (
          <button
            type="button"
            className="btn btn-danger mr-2"
            onClick={(event) => false}
          >
            Deleting...
          </button>
        ) : (
          <button
            type="button"
            className="btn btn-danger mr-2"
            onClick={(event) => {
              handleDeleteClick(event, data);
            }}
          >
            Delete
          </button>
        )} */}
        {/* <button className="btn btn-secondary">Move</button> */}
        <button
          className="btn btn-secondary me-2"
          onClick={(e) => {
            setEditSangathanModal(true);
            handleEditSangathan(data._id, data.name);
          }}
        >
          <i className="fa fa-edit"></i>
        </button>
        {/* <button className="btn btn-primary me-3">
          <i className="fa fa-arrows-alt"></i>
        </button> */}
      </>,
    ],
  }));

  const tableData = {
    columns: [
      {
        label: "Name",
        field: "sangathanName",
        sort: "asc",
        width: 23,
      },
      {
        label: "Users",
        width: 13,
        sort: "asc",
        field: "userCount",
      },
      {
        label: "Action",
        width: 13,
        sort: "asc",
        field: "Action",
      },
    ],
    rows: formattedList,
  };

  return (
    <React.Fragment>
      {isLoading ? (
        <Spinners />
      ) : (
        <Row>
          <Col xl="12">
            <Card>
              <CardHeader>
                <Row>
                  <Col md="12">
                    <CardTitle className="h4 mb-0">Sangathan List</CardTitle>
                    <nav aria-label="breadcrumb">
                      <ol className="breadcrumb">
                        <li className="breadcrumb-item">
                          <Link to="/sangathan-list">Home</Link>
                        </li>

                        {hierarchy.map((item, i) => {
                          const isLast = i === hierarchy.length - 1;
                          return (
                            <li
                              key={item.id}
                              className={`breadcrumb-item ${isLast ? "active" : ""}`}
                              aria-current={isLast ? "page" : undefined}
                            >
                              {isLast ? (
                                item.name
                              ) : (
                                <Link
                                  to={`/parent-sangathan-list/${item.id}`}
                                  state={{
                                    hierarchy: hierarchy.slice(0, i + 1),
                                  }}
                                >
                                  {item.name}
                                </Link>
                              )}
                            </li>
                          );
                        })}
                      </ol>
                    </nav>
                  </Col>
                </Row>
              </CardHeader>
              <CardBody>
                <br />
                <div class="row">
                  <MDBDataTable responsive striped bordered data={tableData} />
                </div>
                <div className="row">
                  {editSangathanModal && (
                    <Modal
                      size="m"
                      centered
                      show={editSangathanModal}
                      backdrop="static"
                      keyboard={false}
                      onHide={() => setEditSangathanModal(false)}
                    >
                      <Modal.Header closeButton>
                        <Modal.Title>Update Sangathan Detail</Modal.Title>
                      </Modal.Header>
                      <form onSubmit={handleEditSubmit}>
                        <Modal.Body>
                          <div className="row">
                            <div className="col-md-12">
                              <div className="form-group">
                                <label for="categoryName" class="form-label">
                                  Sangathan Name
                                  <span class="text-danger"> *</span>
                                </label>
                                <Input
                                  classNamePrefix=""
                                  value={sangathanName}
                                  onChange={(e) => {
                                    setSangathanName(e.target.value);
                                  }}
                                />
                              </div>
                            </div>
                          </div>
                        </Modal.Body>
                        <Modal.Footer>
                          <Button variant="primary" type="submit">
                            Save
                          </Button>
                          <Button
                            variant="secondary"
                            onClick={(e) => setEditSangathanModal(false)}
                          >
                            Close
                          </Button>
                        </Modal.Footer>
                      </form>
                    </Modal>
                  )}
                </div>
                <div className="row">
                  <Modal
                    size="xl"
                    centered
                    show={showModal}
                    backdrop="static"
                    keyboard={false}
                    onHide={() => setShowModal(false)}
                  >
                    <Modal.Header closeButton>
                      <Modal.Title>User List</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                      <div className="row">
                        <table className="table bordered">
                          <thead>
                            <tr>
                              <th>#</th>
                              <th>Name</th>
                              <th>Mobile No.</th>
                              <th>Email</th>
                              <th>VUF Id</th>
                              <th>Role</th>
                            </tr>
                          </thead>
                          <tbody>
                            {sangathanUserList.map((user, item) => (
                              <tr key={user.id}>
                                <td>{item + 1}</td>
                                <td>{user.firstName + "  " + user.lastName}</td>
                                <td>{user.mobileNo}</td>
                                <td>{user.email}</td>
                                <td>{user.vufId}</td>
                                <td>{user.role}</td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </Modal.Body>
                    <Modal.Footer>
                      <Button
                        variant="secondary"
                        onClick={() => setShowModal(false)}
                      >
                        Close
                      </Button>
                    </Modal.Footer>
                  </Modal>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      )}
    </React.Fragment>
  );
};

export default connect(null, { setBreadcrumbItems })(SangathanCreate);
